import { operatorApiFetch } from './apiService';

export const operatorInvitationService = {
  // 列表
  fetchList: async (params = {}) => {
    const response = await operatorApiFetch('operator_invitations', {
      method: 'GET',
      params: params // 假設 operator_invitations 端點支援分頁和篩選
    });
    return response.json();
  },

  // 創建
  create: async (data) => {
    const response = await operatorApiFetch('operator_invitations', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  // 重新發送
  regenerate: async (id) => {
    const response = await operatorApiFetch(`operator_invitations/${id}/regenerate`, {
      method: 'POST',
    });
    return response.json();
  },

  // 刪除
  delete: async (id) => {
    const response = await operatorApiFetch(`operator_invitations/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },
};
export default operatorInvitationService;
